export default __webpack_public_path__ + "static/media/eventbrite.35bb01a9.svg";